import fp from 'lodash/fp'
import { combine, withContext, withCallbacks } from 'react-hooks-combine'
import { withFormModel, withMobxAutorun } from 'shared/hooks'
import { spec, validators } from 'utils/validation'
import { ServicesContext } from 'services/context'

import { toOptions } from 'routes/public/events/overview/components/filters/helpers'
import i18next from 'i18next'
import AthletesFiltersComponent from './component'
import { toSearchableCategory } from './helpers'

const { custom } = validators

export const AthletesFilters = combine(
  withContext(
    'adminAthletesService',
    ServicesContext,
    ({ adminAthletesService }) => adminAthletesService
  ),

  withFormModel(
    {
      search: {
        initialValue: '',
        spec: spec.flow(custom.valid),
      },
      sportTypes: spec.flow(custom.valid),
    },
    { id: 'athletes-filters-form' }
  ),

  withCallbacks(
    {
      loadSportTypes: () => async () => {
        const sportTypes = toOptions(
          i18next.t('enum:sportType', { returnObjects: true })
        )
        return sportTypes
      },
      onSearchRequest: {
        deps: ['debounce', 'onSearch'],
        func: (_state, { debounce, onSearch }) => {
          return fp.isNumber(debounce)
            ? fp.debounce(debounce, onSearch)
            : onSearch
        },
      },
    },
    []
  ),

  withMobxAutorun(
    ({ firstRun, state: { form, onSearchRequest } }) => {
      const search = form.getControl('search')
      const sportTypes = form.getControl('sportTypes')
      const athletesName = search.value
      let sportTypesQuery = null
      if (sportTypes.value) {
        sportTypesQuery = toSearchableCategory(sportTypes.value)
      }

      if (firstRun) {
        return
      }

      onSearchRequest({
        athletesName,
        sportTypes: sportTypesQuery,
      })
    },
    ['onSearchRequest']
  )
)(AthletesFiltersComponent)
